import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import "./index.css";
import "./i18n";
import { queryClient } from "./api/client";
import { ToastProvider } from "./components/Toast";
import { DoneGuardProvider } from "./components/work/DoneGuard";
import { router } from "./router";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <DoneGuardProvider>
          <RouterProvider router={router} />
        </DoneGuardProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
